import $ from 'jquery';
import 'magnific-popup';

if ($('body').hasClass('language-de')) {
    $.extend(true, $.magnificPopup.defaults, {
        overflowY: 'scroll',
        tLoading: 'Lädt...',
        tClose: 'Schließen (ESC)',
        gallery: {
            tPrev: 'Vorheriges Bild',
            tNext: 'Nächstes Bild',
            tCounter: '%curr% von %total%'
        }
    });
}
